export default __webpack_public_path__ + "static/media/contract.b8c0bae4.svg";